import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { DisplayPreference } from '../../../../../../api/types';

const useDisplayPreferenceOptions = () => {
    const { t } = useTranslation('moduleDetails');

    return useMemo(
        () => [
            {
                value: DisplayPreference.Hidden,
                label: t('moduleDetails:explanations.displayPreferences.hidden'),
            },
            {
                value: DisplayPreference.AlwaysShown,
                label: t('moduleDetails:explanations.displayPreferences.alwaysShown'),
            },
            {
                value: DisplayPreference.ShownWhenMoreThanOne,
                label: t('moduleDetails:explanations.displayPreferences.shownWhenMoreThanOne'),
            },
        ],
        [t]
    );
};

export default useDisplayPreferenceOptions;
